import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { CURRENCY } from 'App';
import { MAX_WIN_FOR_TICKET } from 'config/constants';
import { maxStakeFor } from 'helpers/slipHelper';
import styles from './StakeLimit.module.css';

interface Props {
  totalStake: number;
  maxCoefficient: number;
  /** Puts the largest stake within the ticket maximum into the stake field. */
  onStakeMax: (stake: number) => void;
}

/**
 * "Show limit" / "Stake max" on the slip. The ticket pays at most
 * MAX_WIN_FOR_TICKET, so a stake above MAX_WIN / total odds wins nothing more;
 * the player is told the largest useful stake, or can have it filled in.
 */
export const StakeLimit = ({
  totalStake,
  maxCoefficient,
  onStakeMax,
}: Props) => {
  const { t } = useTranslation();
  const maxStake = maxStakeFor(maxCoefficient);
  const overLimit =
    maxCoefficient > 0 && totalStake * maxCoefficient > MAX_WIN_FOR_TICKET;

  return (
    <div className={styles.wrapper}>
      <div className={styles.buttons}>
        <button
          type="button"
          className={classNames(styles.button, styles.active)}
        >
          {t('show_limit_label')}
        </button>
        <button
          type="button"
          className={styles.button}
          disabled={maxStake <= 0}
          onClick={() => onStakeMax(maxStake)}
        >
          {t('stake_max_label')}
        </button>
      </div>
      {overLimit && (
        <div className={styles.message} role="status">
          {t('max_stake_message', {
            amount: maxStake.toFixed(2),
            currency: CURRENCY,
          })}
        </div>
      )}
    </div>
  );
};
